/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as AppStoreDownloadBadgeUS } from '../../assets/svg/app-store-download-badge-US.svg';
export default AppStoreDownloadBadgeUS;
